import LocalStorageService from "./LocalStorageService";
import {baseUrl} from "./Api";
const localStorage = LocalStorageService.getService();

class Auth {
    async login(data) {
        await fetch(`${baseUrl}token-auth/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status !== 200) {
                    throw new Error('Login Failed!');
                } else {
                    res.json()
                        .then(json => {
                            if (json.token) {
                                localStorage.setToken(json.token);
                                return json
                            }

                            return null
                        })
                        .then(() => {
                            window.location = '/';
                        });
                }
            })
    }

    async logout(cb) {
        localStorage.clearToken();
        await cb();
    }

    isAuthenticated() {
        return localStorage.getAccessToken() && localStorage.getAccessToken() !== 'undefined'
    }
}

export default new Auth()